import axios from "axios";

const campaignId = process.env.REACT_APP_TENANT_ID;
const baseUri = process.env.REACT_APP_AUTH_ENDPOINT;
const logoutUri = process.env.REACT_APP_LOGOUT_URI;

const getDefaultHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
}

export const decrypt = async (sso) => {
  const config = {
    headers: getDefaultHeaders(),
  }

  const body = {
    projectId: campaignId,
    data: sso,
  };

  try {
    const { data: decryptedMsg } = await axios.post(`${baseUri}/encryption/sso/decrypt`, body, config);

    return decryptedMsg.data;
  } catch (err) {
    console.log(err);

    window.location.href = logoutUri || '/';
  }
}
